import React, { useEffect, useState } from 'react';
import { Button, Center, Input, VStack, Text } from 'native-base';
import { useNavigation } from '@react-navigation/native';
import { User, getAuth, onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc, updateDoc, getFirestore } from 'firebase/firestore';
import { initializeApp } from 'firebase/app';
import { firebaseConfig } from '../../firebaseConfig';


const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);


const ActivationScreen = () => {
  const [error, setError] = useState<string | null>(null);
  const [isActive, setIsActivated] = useState<boolean | null>(null);
  const [codeInput, setCodeInput] = useState<string>('');


  const navigation = useNavigation();

  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState<User | null>(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      setLoading(true);
      if (user) {
        try {
          const userRef = doc(db, 'users', user.uid);
          const userSnap = await getDoc(userRef);

          if (userSnap.exists()) {
            const userData = userSnap.data();
            setIsActivated(userData.isActive);
            setUser(user);
          } else {
            setUser(null);
          }
        } catch (error) {
          console.error('Erro ao carregar o estado do usuário:', error);
        }
      } else {
        setUser(null);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  const handleVerifyCode = async () => {
    if (!user) return;

    const userRef = doc(db, 'users', user.uid);
    const userSnap = await getDoc(userRef);

    if (userSnap.exists() && userSnap.data().activationCode === codeInput) {
      await updateDoc(userRef, { isActive: true });
      setIsActivated(true);
      setError(null);
      alert('Código válido!');
      navigation.navigate('Home');
    } else {
      setError('Código de ativação inválido');
    }
  };

  return (
      <Center flex={1} p={4} background={'#fff'}>
        <Text fontWeight="bold" fontSize="xl" pl={4} pr={4} mb={4}>
          Digite o código enviado para seu email ou whatsapp
        </Text>
        <VStack space={4} width="80%">
          <Input
              borderRadius="25px"
              borderColor="#384085"
              height="50px"
              placeholder="Código"
              value={codeInput}
              onChangeText={setCodeInput}
              type="text"
              variant="outline"
              paddingLeft="15px"
          />
          <Center>
            <Button
                borderRadius="25px"
                background="#384085"
                width="144px"
                height="50px"
                onPress={handleVerifyCode}
                _text={{ color: "#fff", fontWeight: "500", fontSize: "16px" }}
            >
              Validar
            </Button>
          </Center>
        </VStack>
      </Center>
  );
};

export default ActivationScreen;
